import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import {
  HeaderTitle,
  IHeaderItem,
  Mode,
  ModeType
} from 'src/app/models/generic';
import { ApiLotDetailService } from 'src/app/services/api/api-lot-detail.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-lotes-faturamento',
  templateUrl: './lotes-faturamento.component.html',
  styleUrls: ['./lotes-faturamento.component.scss']
})
export class LotesFaturamentoComponent implements OnInit, OnDestroy {
  title = 'Faturamento dos Contratos';

  Mode = Mode;

  routeDetailSubscription!: Subscription;

  headerItems: IHeaderItem[] = [
    { label: 'Status', flexSize: 2, justify: 'center' },
    { label: 'Lote', flexSize: 4, name: 'BatchNumber', isOrder: true, orderValue: 0 },
    { label: 'Tipo de Operação', flexSize: 3, name: 'OperationType', isOrder: true, orderValue: 0 },
    { label: 'BPO/Regional', flexSize: 3, isOrder: true, orderValue: 0 },
    {
      label: 'Data do Lote',
      flexSize: 4,
      name: 'CreateDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Data de Recebimento',
      flexSize: 4,
      name: 'CreateDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Data de envio e-mail',
      flexSize: 4,
      name: 'EmailInvoiceDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Banco',
      flexSize: 4,
      name: 'Bank',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Valor Faturado',
      flexSize: 4,
      name: 'AmountTotal',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Qt. de Contratos',
      flexSize: 4,
      name: 'NumberOfContracts',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Status Faturamento',
      flexSize: 4,
      name: 'BatchStatus',
      isOrder: true,
      orderValue: 0
    },
    { label: '', flexSize: 1 }
  ];

  constructor(
    private _dataService: DataService,
    private _activatedRoute: ActivatedRoute,
    private _lotDetailService: ApiLotDetailService,
    private _router: Router
  ) {
    const title = _activatedRoute.snapshot.routeConfig?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  ngOnInit() {
    this.listeningEvents();
  }

  ngOnDestroy(): void {
    if (this.routeDetailSubscription) {
      this.routeDetailSubscription.unsubscribe();
    }
  }

  listeningEvents(): void {
    this._lotDetailService.routeToDetailEvent.subscribe((lotInfo) => {
      this._router.navigate(['detalhes-lote', lotInfo.lotId], {
        relativeTo: this._activatedRoute
      });
    });
  }
}
